<template>
    <div class="diaporama-slider">
        <div class="radial"></div>
        <tiny-slider
                ref="ts"
                :mouse-drag="true"
                :loop="true"
                :autoplay="autoplay"
                :autoplayButtonOutput="false"
                :items="1"
                :nav="false"
                :controls="false"
                :speed="1000"
                :autoplayTimeout="5000"
                gutter="0"
        >
            <div class="slide"
                 v-for="media in medias"
                 :key="media.src"
            >
                <img :src="media.imageUrl()"/>
                <div class="image-filter"></div>
                <legende-deco>
                    {{media.legende}}
                </legende-deco>
            </div>
        </tiny-slider>

        <a href="#"
           @click.prevent="next"
           class="btn-next">
            <icon-base size="5vw" icon-color="#fff">
                <icon-caret-right></icon-caret-right>
            </icon-base>
        </a>
        <a  href="#"
            @click.prevent="prev"
            class="btn-prev">
            <icon-base size="5vw" icon-color="#fff">
                <icon-caret-left></icon-caret-left>
            </icon-base>
        </a>

    </div>
</template>

<script>
    import VueTinySlider from 'vue-tiny-slider';
    import LegendeDeco from 'shared-src/comp/LegendeDeco';
    import IconBase from "shared-src/icons/IconBase";
    import IconCaretLeft from "shared-src/icons/IconCaretLeft";
    import IconCaretRight from "shared-src/icons/IconCaretRight";
    export default {
        name: "Diaporama",
        components: {
            'tiny-slider': VueTinySlider,
            LegendeDeco,
            IconBase,
            IconCaretLeft,
            IconCaretRight,
        },
        props:{

            /**
            * @type {MediaImage[]}
            */
            medias:{
              type:Array
            }
        },
        data() {
            return {
                autoplay:true,
            }
        },
        methods:{
            prev(){
                this.$refs.ts.goTo('prev');
                //this.$refs.ts.pause();
                this.$refs.ts.slider.pause();
            },
            next(){
                this.$refs.ts.goTo('next');
                //this.$refs.ts.pause();
                this.autoplay=false;
                this.$refs.ts.slider.pause();
            }
        }
    }
</script>

<style lang="less">
    @import "~tiny-slider/dist/tiny-slider.css";
    .diaporama-slider{
        .radial{
            //background: radial-gradient(ellipse, rgba(0,0,0,0.0) 50%, rgba(0,0,0,0.5) 100%);
            background: radial-gradient(ellipse, rgba(0,0,0,0.0) 70%, rgba(0, 0, 0, 0.5) 100%);
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            z-index: 1;
            pointer-events: none;
        }
        position: relative;
        height: 100%;
        width: 100%;
        background-color: #000;
        .slide{
            height: 100vh;
            position: relative;
            .legende-deco{
                position: absolute;
                bottom: 2vw;
                left: 50%;
                transform: translateX(-50%);
                text-shadow: 0px 0px 8px #000, 0px 0px 2px #000;
            }
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
          .image-filter{
            background: linear-gradient( rgba(0,0,0,0.0) 80%, rgba(0, 0, 0, 0.5) 100%);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        }


        .btn-next,.btn-prev{
            position: absolute;
            z-index: 2;
            top: calc( 50% - 2.5vw);
            svg{
                pointer-events: none;
            }
        }
        .btn-next{
            right: 1vw;
        }
        .btn-prev{
            left: 1vw;
        }
    }
</style>